// src/helpers/Global.js
const host = "116.203.90.208";   // ej. "localhost" o "192.168.1.7"
const API_PORT = 5000;

// src/helpers/Global.js
export const Global = {
  url: "/api/",
  loginPrimary: "mail",
  rango_metros: 1000,
};

